import React, { PropsWithChildren } from "react";

/* Interfaces */
import { StoreType } from "../interfaces/store_types";

/* Providers */
import { StoreContext } from "./StoreContext";
import { PaymentTypeProvider } from "./PaymentTypeContext";

interface StoreProviderProps {
  store: StoreType;
}

export const StoreProvider: React.FC<
  StoreProviderProps & PropsWithChildren
> = ({ store, children }) => {
  return (
    <StoreContext.Provider value={{ store }}>
      <PaymentTypeProvider>{children}</PaymentTypeProvider>
    </StoreContext.Provider>
  );
};
